import React, { useState, useEffect, useContext } from "react";
import "../../App.css"; // Import global styles
import AnimalWelfareGroupImage from "../../images/charity Images/Animal_Welfare_Groups.png"; // Importing the image
import ArtsAssociationImage from "../../images/charity Images/Arts_Associations.png"; // Importing the image
import ChildcareOrganizationsImage from "../../images/charity Images/Childcare_Organisations.png"; // Importing the image
import CommunityShedsImage from "../../images/charity Images/Community_Sheds.png"; // Importing the image
import EnvironmentalGroupsImage from "../../images/charity Images/Environmental_Groups.png"; // Importing the image
import HealthPromotionCharitiesImage from "../../images/charity Images/Health_Promotion_Charities.png"; // Importing the image
import HospitalsHealthcareProvidersImage from "../../images/charity Images/Hospital_Heathcare_Providers.png"; // Importing the image
import HousingProvidersImage from "../../images/charity Images/Housing_Providers.png"; // Importing the image
import MedicalResearchInstitutesImage from "../../images/charity Images/Medical_Research_Insitute.png"; // Importing the image
import PrivatePublicAncillaryFundsImage from "../../images/charity Images/Public_Private_Ancillary_Funds.png"; // Importing the image
import PublicBenevolentInstitutionsImage from "../../images/charity Images/Public_Benevolent_Institutes.png"; // Importing the image
import SocialClubsImage from "../../images/charity Images/Social_Clubs.png"; // Importing the image
import SportingClubsAssociationsImage from "../../images/charity Images/Sporting_Clubs_Association.png"; // Importing the image
import SchoolEducationProvidersImage from "../../images/charity Images/School_Education_Providers.png"; // Importing the image
import SelfHelpGroupsImage from "../../images/charity Images/Self_Help_Groups.png"; // Importing the image

import { UserContext } from "../context/UserContext";

const AddCharities = ({ onClose, charity = null, handleSubmit }) => {
  // Helper function to format date to dd/mm/yyyy
  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = new Date(date); // Parse the date string
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = parsedDate.getFullYear();
    return `${day}/${month}/${year}`;
  };
  
  
  const { emailId } = useContext(UserContext);
  const [charityTitle, setCharityTitle] = useState(
    charity?.charity_title || ""
  );
  const [selectedCategory, setSelectedCategory] = useState(
    charity?.category || ""
  );
  const [targetAmount, setTargetAmount] = useState(
    charity?.target_amount || ""
  );
  const [currency, setCurrency] = useState(charity?.currency || "AUD");
  const [description, setDescription] = useState(charity?.description || "");
  const [endDate, setEndDate] = useState(
    charity ? formatDate(charity.end_date) : ""
  );

  const [imageFile, setImageFile] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(
    charity?.image_url || ""
  );
  const [currentPage, setCurrentPage] = useState(charity ? 2 : 1); // Default to page 2 for editing

  const [mediaFile, setMediaFile] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [mediaUrl, setMediaUrl] = useState(charity?.media_url || "");

  const currencies = ["AUD"]; // Currency options

  const [endDay, setEndDay] = useState("");
const [endMonth, setEndMonth] = useState("");
const [endYear, setEndYear] = useState("");

  // Add these states at the top with other state declarations
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Add new states for banking details
  const [accountName, setAccountName] = useState(charity?.account_name || "");
  const [accountNumber, setAccountNumber] = useState(charity?.account_number || "");
  const [bsbNumber, setBsbNumber] = useState(charity?.bsb_number || "");

  // Updated categories with the correct image import
  const categories = [
    { name: "Animal Welfare Groups", img: AnimalWelfareGroupImage },
    { name: "Arts Association", img: ArtsAssociationImage },
    { name: "Childcare Organizations", img: ChildcareOrganizationsImage },
    { name: "Community Sheds", img: CommunityShedsImage },
    { name: "Environmental Groups", img: EnvironmentalGroupsImage },
    { name: "Health Promotion Charities", img: HealthPromotionCharitiesImage },
    { name: "Hospitals & other Healthcare providers", img: HospitalsHealthcareProvidersImage },
    { name: "Housing Providers", img: HousingProvidersImage },
    { name: "Medical Research Institutes", img: MedicalResearchInstitutesImage },
    { name: "Private & public Ancillary Fund", img: PrivatePublicAncillaryFundsImage },
    { name: "Public Benevolent Institutions", img: PublicBenevolentInstitutionsImage },
    { name: "Social Clubs", img: SocialClubsImage },
    { name: "Sporting Clubs & Associations", img: SportingClubsAssociationsImage },
    { name: "School & other education providers", img: SchoolEducationProvidersImage },
    { name: "Self-Help Groups", img: SelfHelpGroupsImage },
  ];

  // Prevent negative amounts in the Target Amount field
  const handleTargetAmountChange = (e) => {
    const value = e.target.value;
    if (value >= 0) {
      setTargetAmount(value);
    }
  };

  // Handle end date selection
  const handleEndDateChange = (day, month, year) => {
    if (!day || !month || !year) {
      setEndDate("");
      return;
    }

    // Format the date properly
    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    setEndDate(formattedDate);
  };
  
  
  // Navigate to the next page
  const handleNextPage = () => {
    if (currentPage === 1 && !selectedCategory) {
      alert("Please select a category!");
      return;
    }
    setCurrentPage(2); // Move to page 2
  };

  // Navigate to the previous page
  const handlePreviousPage = () => {
    setCurrentPage(1); // Move back to page 1
  };

  // Add this function to handle image upload to S3
  const uploadImageToS3 = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch("/api/upload-s3", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Image upload failed");

      const data = await response.json();
      return data.imageUrl;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  // Add validation function
  const validateFile = (file) => {
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const allowedVideoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
    const maxSize = 500 * 1024 * 1024; // 100MB

    if (![...allowedImageTypes, ...allowedVideoTypes].includes(file.type)) {
      alert('Invalid file type. Only images (JPG, PNG, GIF) and videos (MP4, MOV, AVI) are allowed.');
      return false;
    }

    if (file.size > maxSize) {
      alert('File is too large. Maximum size is 500MB.');
      return false;
    }

    return true;
  };

  // Update file input handler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setMediaFile(file);
      setMediaType(file.type);
    }
  };

  // Update upload function
  const uploadMediaToS3 = async (file) => {
    const formData = new FormData();
    formData.append("media", file);

    try {
      const response = await fetch("/api/upload-s3", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Media upload failed");

      const data = await response.json();
      return { url: data.mediaUrl, type: data.mediaType };
    } catch (error) {
      console.error("Error uploading media:", error);
      throw error;
    }
  };

  // Add validation handlers for BSB and Account numbers
  const handleBsbNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) { // Limit to 6 digits
      setBsbNumber(value);
    }
  };

  const handleAccountNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 10) { // Limit to 10 digits
      setAccountNumber(value);
    }
  };

  //TODO
  // Save project on submission
  const handleSaveProject = async () => {
    console.log(charityTitle, selectedCategory, targetAmount, description, endDate, mediaFile);
    if (!charity && (!selectedCategory || !charityTitle || !targetAmount || !description || !endDate || !mediaFile || !accountName || !accountNumber || !bsbNumber)) {
      alert("Please fill out all fields to add a new charity!");
      return;
    }

    setIsSubmitting(true);
    setUploadProgress(0);
    
    try {
      let imageUrl = uploadedImageUrl;
      let mediaData = { url: mediaUrl, type: mediaType };

      // Start with 10% progress for initialization
      setUploadProgress(10);

      if (imageFile) {
        // Update progress to 30% when starting image upload
        setUploadProgress(30);
        imageUrl = await uploadImageToS3(imageFile);
      }

      // Update progress to 50% after image upload
      setUploadProgress(50);

      if (mediaFile) {
        // Update progress to 70% when starting media upload
        setUploadProgress(70);
        mediaData = await uploadMediaToS3(mediaFile);
      }

      // Update progress to 80% after media upload
      setUploadProgress(80);

      const formData = {
        project_title: charityTitle || charity?.charity_title,
        category: selectedCategory || charity?.category,
        target_amount: targetAmount ? parseFloat(targetAmount) : charity?.target_amount,
        currency: currency || charity?.currency,
        description: description || charity?.description,
        image_url: mediaData.url,
        media_type: mediaData.type,
        end_date: endDate || charity?.end_date,
        email_id: emailId,
        type: 'charity',
        account_name: accountName || charity?.account_name,
        account_number: accountNumber || charity?.account_number,
        bsb_number: bsbNumber || charity?.bsb_number,
      };

      // Update progress to 90% before final submission
      setUploadProgress(90);

      let response;
      if (charity) {
        response = await fetch(`/api/projectlist/${charity.project_id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      } else {
        response = await fetch("/api/projectlist", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      }

      if (response.status === 500) {
        const errorData = await response.json();
        alert(`❌ Submission flagged for inappropriate content or other issues, please contact admin`);
        return;
      }

      if (!response.ok) {
        throw new Error(`Failed to ${charity ? "update" : "create"} project`);
      }

      // Set progress to 100% on successful completion
      setUploadProgress(100);

      const result = await response.json();
      alert(`✅ Charity '${charityTitle}' ${charity ? "updated" : "added"} successfully!`);

      onClose();
    } catch (error) {
      console.error("🚨 Error submitting form:", error);
      alert("An unexpected error occurred. Please try again.");
    } finally {
      // Add a small delay before closing the progress bar to make it visible
      setTimeout(() => {
        setIsSubmitting(false);
        setUploadProgress(0);
      }, 1000);
    }
  };
  

  return (
    <div
      className="popup-section"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        className="popup-container"
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          width: "95%", // Increased width
          maxWidth: "900px", // Increased max-width
          maxHeight: "90vh", // Set a maximum height
          overflowY: "auto", // Enable scrolling if content overflows
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          position: "relative",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          {charity ? "Edit Charity" : "Add New Charity"}
        </h3>

        {/* Close Button */}
        <button
          onClick={onClose} // Ensure this is correctly passed and invoked
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        {/* Multi-page Form */}
        {currentPage === 1 &&
          !charity && ( // Only show this step if adding a new project
            <form>
              {/* Page 1: Categories */}
              <div style={{ marginBottom: "15px", textAlign: "center" }}>
                <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Select a Category:
                </p>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    margin: "0 auto",
                    textAlign: "center",
                  }}
                >
                  <tbody>
                    {Array.from({ length: 7 }).map((_, rowIndex) => (
                      <tr key={rowIndex}>
                        {categories
                          .slice(rowIndex * 5, rowIndex * 5 + 5) // Extract 5 items for each row
                          .map((category, colIndex) => (
                            <td
                              key={colIndex}
                              style={{
                                padding: "10px",
                                border: "1px solid white",
                                borderRadius: "5px",
                                backgroundColor:
                                  selectedCategory === category.name
                                    ? "#007bff"
                                    : "white",
                                color:
                                  selectedCategory === category.name
                                    ? "white"
                                    : "#333",
                                cursor: "pointer",
                                height: "120px", // Set to match the image's height
                                verticalAlign: "middle", // Center content vertically
                              }}
                              onClick={() => setSelectedCategory(category.name)} // Set the selected category
                            >
                              {category.img ? (
                                <img
                                  src={category.img}
                                  alt={category.name}
                                  style={{
                                    width: "90px", // Adjusted to match aspect ratio
                                    height: "90px", // Adjusted to match aspect ratio
                                    marginBottom: "5px",
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              ) : null}
                              {category.name}
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Navigation Buttons */}
              {!charity && ( // Only show "Next" button in Add mode
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={handleNextPage}
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          )}

        {currentPage === 2 && (
          <form>
            {/* Page 2: Project Details */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="charityTitle"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Charity Title:
              </label>
              <input
                id="charityTitle"
                type="text"
                value={charityTitle}
                onChange={(e) => setCharityTitle(e.target.value)}
                placeholder="Enter charity title"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  backgroundColor: charity ? "#f8f9fa" : "white", // Subtle gray background for read-only
                  cursor: charity ? "not-allowed" : "text", // Change cursor for read-only
                }}
                readOnly={!!charity} // Makes the field read-only if the component is in edit mode
              />
              {charity && (
                <small
                  style={{
                    color: "#6c757d",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  Charity title cannot be changed while editing.
                </small>
              )}
            </div>

            {/* Target Amount */}
            {/* Target Amount */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="targetAmount"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Your Target Amount:
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                <select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  style={{
                    border: "none",
                    background: "none",
                    color: "#00d4ff",
                    fontWeight: "bold",
                    outline: "none",
                    width: "60px", // Compact dropdown width
                    textAlign: "center",
                    appearance: "none", // For consistent dropdown styling
                  }}
                >
                  {currencies.map((cur) => (
                    <option key={cur} value={cur}>
                      {cur}
                    </option>
                  ))}
                </select>
                <span
                  style={{
                    margin: "0 10px", // Spacing around the separator
                    color: "#ccc", // Light gray for the separator
                    fontWeight: "bold",
                  }}
                >
                  |
                </span>
                <input
                  id="targetAmount"
                  type="number"
                  value={targetAmount}
                  onChange={handleTargetAmountChange}
                  placeholder="Enter target amount"
                  style={{
                    border: "none",
                    outline: "none",
                    flex: 1, // Let the input field take up remaining space
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            {/* End Date */}
          {/* Updated End Date Section */}
        {/* Updated End Date Section with Dropdowns */}
            <div style={{ marginBottom: "15px", textAlign: "left" }}>
              <label
                htmlFor="endDate"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                End Date:
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start", // Align everything to the left
                  gap: "10px",
                }}
              >
                {/* Day Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endDay"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Day
                  </label>
                  <select
                    id="endDay"
                    value={endDay}
                    onChange={(e) => {
                      const updatedDay = e.target.value;
                      setEndDay(updatedDay);
                      handleEndDateChange(updatedDay, endMonth, endYear);
                    }}
                    style={{
                      width: "80px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">DD</option>
                    {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Dash Separator */}
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>-</span>

                {/* Month Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endMonth"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Month
                  </label>
                  <select
                    id="endMonth"
                    value={endMonth}
                    onChange={(e) => {
                      const updatedMonth = e.target.value;
                      setEndMonth(updatedMonth);
                      handleEndDateChange(endDay, updatedMonth, endYear);
                    }}
                    style={{
                      width: "80px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">MM</option>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Dash Separator */}
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>-</span>

                {/* Year Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endYear"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Year
                  </label>
                  <select
                    id="endYear"
                    value={endYear}
                    onChange={(e) => {
                      const updatedYear = e.target.value;
                      setEndYear(updatedYear);
                      handleEndDateChange(endDay, endMonth, updatedYear);
                    }}
                    style={{
                      width: "100px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">YYYY</option>
                    {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i).map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Display the formatted date */}
              {endDate && (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginTop: "10px",
                  }}
                >
                  Selected Date: {endDate}
                </p>
              )}
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="description"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Description:
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter project description"
                rows="4"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  resize: "none",
                }}
              />
            </div>

            {/* Image Upload or URL */}
            {/* <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="imageUpload"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Upload Project Image:
              </label>
              <input
                id="imageUpload"
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div> */}

            {/* Media Upload */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="mediaUpload"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Upload Charity Image or Video, max 500MB, Accepted formats: jpeg, png, GIF, MP4, quicktime, x-msvideo:
              </label>
              <input
                id="mediaUpload"
                type="file"
                accept="image/*,video/*"
                onChange={handleFileChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
              {mediaFile && (
                <div style={{ marginTop: "10px" }}>
                  {mediaType?.startsWith('image/') ? (
                    <img 
                      src={URL.createObjectURL(mediaFile)} 
                      alt="Preview" 
                      style={{ maxWidth: "200px" }} 
                    />
                  ) : (
                    <video 
                      controls 
                      style={{ maxWidth: "200px" }}
                    >
                      <source src={URL.createObjectURL(mediaFile)} type={mediaType} />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              )}
            </div>

            {/* Add new banking fields before the submit button */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="accountName"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Account Name:
              </label>
              <input
                id="accountName"
                type="text"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                placeholder="Enter account name"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="accountNumber"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Account Number (9-10 digits):
              </label>
              <input
                id="accountNumber"
                type="text"
                value={accountNumber}
                onChange={handleAccountNumberChange}
                placeholder="Enter account number"
                minLength="9"
                maxLength="10"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="bsbNumber"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                BSB Number (6 digits):
              </label>
              <input
                id="bsbNumber"
                type="text"
                value={bsbNumber}
                onChange={handleBsbNumberChange}
                placeholder="Enter BSB number"
                minLength="6"
                maxLength="6"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            {/* Navigation Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ffc107",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handlePreviousPage}
              >
                Back
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handleSaveProject}
              >
                Submit
              </button>
            </div>
          </form>
        )}
      </div>

      {/* Add this progress bar overlay right before the closing div of your return statement */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
                Uploading your charity...
              </div>
              <div
                style={{
                  width: "100%",
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${uploadProgress}%`,
                    height: "100%",
                    backgroundColor: "#4CAF50",
                    borderRadius: "10px",
                    transition: "width 0.3s ease-in-out",
                  }}
                />
              </div>
              <div style={{ marginTop: "10px", fontSize: "14px" }}>
                {uploadProgress}% Complete
              </div>
            </div>
            <div style={{ color: "#666", fontSize: "14px" }}>
              Please wait while we process your charity...
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCharities;
